import * as React from 'react';
import { LeftOutlined } from '@ant-design/icons';

import { WarningIcon } from '@components';
import { Button } from '@frontend/shadcn/components/ui/button';

interface IProps {
    onConfirm: () => void;
    onDismissConfirmation: () => void;
}

export const RefreshConfirmClose: React.FC<Readonly<IProps>> = (props) => {
    const {
        onConfirm,
        onDismissConfirmation,
    } = props;
    return (
      <div className="flex flex-col gap-4 justify-center items-center">
        <WarningIcon size={80} />
        <h2>
          Are you sure you want to cancel?
        </h2>
        <p>
          If you close now before finishing you will lose your progress.
        </p>
        <div className="flex gap-2">
          <Button onClick={onDismissConfirmation} variant="outline">
            <LeftOutlined />
            Back
          </Button>
          <Button onClick={onConfirm} variant="destructive">
            Discard Changes
          </Button>
        </div>
      </div>
    );
};

RefreshConfirmClose.displayName = 'RefreshConfirmClose';
